// BACKUP REDUCER
const initialState = {
  fetched: false,
  loading: false,
  selected: {},
  one: {},
  error: null,
  all: [],
  allCloneable: {
    backups: [],
    pagination: {},
    // Whether these rows came from another environment, recorded with them: ids are scoped to the
    // environment that issued them, so an id here means nothing without it.
    foreign: false
  },
  pagination: {},
  // The query behind the rows in `all`, so a refetch can reproduce this exact page rather than reset to the first.
  lastQuery: null
};
export default function backupReducer(state = initialState, action) {
  switch (action.type) {
    case 'BACKUP_LOADING': {
      return {
        ...state,
        loading: true,
        allCloneable: initialState.allCloneable
      };
    }
    case 'BACKUP_GETALL_SUCCESS': {
      return {
        ...state,
        fetched: true,
        loading: false,
        lastQuery: action.query || initialState.lastQuery,
        all: action.payload.content,
        pagination: {
          last: action.payload.isLast,
          totalElements: action.payload.totalElements,
          totalPages: action.payload.totalPages,
          size: action.payload.size,
          number: action.payload.number,
          first: action.payload.isFirst,
          sort: action.payload.sort,
          numberOfElements: action.payload.numberOfElements
        }
      };
    }
    case 'BACKUP_GETALL_CLONEABLE_SUCCESS': {
      return {
        ...state,
        loading: false,
        allCloneable: {
          ...state.allCloneable,
          foreign: !!action.foreign,
          backups: action.payload.content,
          pagination: {
            last: action.payload.last,
            totalElements: action.payload.totalElements,
            totalPages: action.payload.totalPages,
            size: action.payload.size,
            page: action.payload.number,
            first: action.payload.first,
            numberOfElements: action.payload.numberOfElements
          }
        }
      };
    }
    case 'BACKUP_DELETE_SUCCESS': {
      return {
        ...state,
        one: initialState.one,
        error: initialState.error
      };
    }
    case 'BACKUP_CREATE_ERROR':
    case 'BACKUP_DELETE_ERROR':
    case 'BACKUP_PIN_ERROR':
    case 'BACKUP_UNPIN_ERROR': {
      return {
        ...state,
        error: action.payload
      };
    }
    case 'BACKUP_PIN_SUCCESS':
    case 'BACKUP_UNPIN_SUCCESS': {
      // The endpoint returns the updated backup, so swap that one row in place. A null payload means the
      // action could not read one back and is refetching the list, so leave the rows to that.
      const updated = action.payload;
      return {
        ...state,
        error: initialState.error,
        all: updated && updated.id ? state.all.map(b => (b.id === updated.id ? updated : b)) : state.all
      };
    }
    case 'BACKUP_CREATE_SUCCESS': {
      return {
        ...state,
        one: initialState.one,
        // Clears a failed earlier attempt, so a successful retry is not followed by its own failure notice.
        error: initialState.error
      };
    }
    case 'BACKUP_RESTORE_SUCCESS': {
      return {
        ...state,
        one: initialState.one
      };
    }
    case 'BACKUP_SELECT': {
      return {
        ...state,
        selected: action.payload
      };
    }
    case 'BACKUP_CLEAR': {
      return {
        ...state,
        one: initialState.one,
        allCloneable: initialState.allCloneable
      };
    }
    case 'BACKUP_CLEAR_ERROR': {
      return {
        ...state,
        error: initialState.error
      };
    }
  }
  return state;
}
